import * as React from "react";
import { Template, Product } from "typings/index";
import { TextField, Label, Dropdown, IDropdownOption, Button, PrimaryButton } from "office-ui-fabric-react/lib";
export interface Props
{
    templates: Template[];
    products: Product[];
    onCreate: (name: string, templateId: string) => void;
    onCancel: () => void;
}

interface State
{
 
    name: string; 
    templateId: string;
    error:{fieldName: string, message: string} [];
}

class New extends React.Component<Props, Partial<State>>
{
    state:Partial<State>= {
        name: undefined,
        templateId: undefined,
        error:[]
        
    };
    setProperty = ( key: "name"  ) => (e: React.FormEvent<HTMLInputElement  | HTMLTextAreaElement>, value: string) =>
    {
        this.setState({ [key]: value});
    }

    onCreate = () =>
    {
        const {name, templateId } = this.state;
       
        if (name && templateId)
        {
           
            this.setState({ error: [] });
            this.props.onCreate(name, templateId);
            return;
        }
        const errors = [];
        if (!name)
        {
            errors.push( {fieldName: "name", message: "Required"});
        }
        if (!templateId)
        {
            errors.push( {fieldName: "templateId", message: "Required"});
        }
        this.setState({ error: errors });

    }

    onDropDownChange = (e: React.FormEvent<HTMLDivElement>, item: IDropdownOption) =>
    {
        if (item.key)
        {
            this.setState({ templateId: item.key.toString()});
        }
    }

    render()
    {

        const dropdownOptions: IDropdownOption[] = this.props.templates.map(x => ({ text: x.label._DEFAULT, key: x.id }));
        const nameError = this.state.error && this.state.error.find(x => x.fieldName === "name");
        const templateIdError = this.state.error && this.state.error.find(x => x.fieldName === "templateId");
        return (
            <form>
                <Label htmlFor="newProductName">Product name</Label>
                <TextField autoFocus errorMessage={nameError && nameError.message} required onChange={this.setProperty("name")} id="newProductName">
                </TextField>
                <Label htmlFor="newProductTemplate">Product data template</Label>
                <Dropdown errorMessage={templateIdError && templateIdError.message} 
                        onChange={this.onDropDownChange} required id="newProductTemplate" 
                        options={dropdownOptions}  />
                <Button onClick={this.props.onCancel}>Cancel</Button>
                <PrimaryButton onClick={this.onCreate}>Create</PrimaryButton>
            </form>
        );
    }
}

export default New;


// WEBPACK FOOTER //
// ./src/components/product/New.tsx